import { Field, TextOutput, Checkbox } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent, WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { prefixRecordFieldSetNames } from 'Components/Worksheets/Core/WorksheetRecordGrid/helpers';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { getGridFieldSet as getMoistureContentGridFieldSet } from 'Components/Worksheets/MoistureContentWorksheet/BsEnIso/gridFieldSets';
import deepEquals from 'Lib/Object/deepEquals';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';

let BsCompactionMoistureContentDeterminationGridSection: React.FC<IWorksheetComponent> = ({
  createWorksheetSelector,
}) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));
  const testPortionRecordProps = useSelector(
    pipe(createWorksheetSelector!('TestPortions'), (portions) =>
      (portions ?? []).map((p: any) => ({
        dim: p.ExcludedPoint,
      }))
    ),
    deepEquals
  );

  return (
    <WorksheetGridFieldSection name="TestPortions">
      <WorksheetRecordGrid
        name={'TestPortions'}
        orientation={'horizontal'}
        rowHeaderWidth={200}
        scrollLinkId="mddCompaction"
        recordProps={{
          width: 130,
          preventRemove: true, // Removed in another, related grid
          dim: (i) => testPortionRecordProps[i]?.dim,
          heading: 'number',
          headingLabel: 'Test Portion ID',
        }}
        fieldSet={[
          ...prefixRecordFieldSetNames('MoistureDetermination', getMoistureContentGridFieldSet(dryMassEntryOption)),
          {
            name: 'DryDensity',
            component: <Field input={<TextOutput />} />,
          },
          {
            name: 'ExcludedPoint',
            component: <Field input={<Checkbox />} />,
          },
        ]}
      />
    </WorksheetGridFieldSection>
  );
};

BsCompactionMoistureContentDeterminationGridSection = withInjectedProps(
  BsCompactionMoistureContentDeterminationGridSection
);

export { BsCompactionMoistureContentDeterminationGridSection };
export default BsCompactionMoistureContentDeterminationGridSection;
